import { Component, OnInit } from '@angular/core';
import { LoginService } from './services/login.service';
import { IGetOperationResponse } from '../shared/interfaces/IGetOperationResponse';
import { IApplicantLoginResponse } from '../shared/interfaces/IApplicantLoginResponse';
import { LoaderService } from 'src/modules/shared/services/loader.service';
import { UserConfigService } from 'src/modules/shared/services/userConfig.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { IOptionSetItem } from '../shared/interfaces/IOptionSetItem';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { CommonService } from '../shared/services/common.service';
import { ApplicantManagementService } from '../profile-management/services/applicant-management-service.service';
import { IUserAuthenticationInfo } from '../shared/interfaces/IUserAuthenticationInfo';
import { Mode } from '../shared/form-guide/utility/enums/enums';
import { PopupNotificationComponent } from '../shared/request/popup-notification/popup-notification.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { AppConfigService } from '../shared/services/app-config.service';
import { UserLoginsDbStoreName } from "../shared/IndexedDB/userLoginsDb";
import { EKeyAuthService } from '../shared/services/Ekey-auth.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  //#region [Variables]
  authenticationInfo: IUserAuthenticationInfo = {};
  alertModalRef: BsModalRef;

  selectedCRNumber: string;
  applicantCrs: { Key: string, Value: string }[] = [];
  selectedType: number = 1;
  CPRNumber: string;
  authSource: string;
  userData: { UserType?: number, UserCPR?: string, UserCR?: string, Module?: number } = {};
  applicantResponse: IApplicantLoginResponse = {};
  message: string;
  showThereIsNoCrMessage: boolean = false;
  showErrorMessage: boolean = false;
  responseErrorMessage: string;
  retrievedModuleValue: number;

  Modules: IOptionSetItem[];
  crsModules: CrModules[];

  currentUser: { lang?: string; type?: string; cr?: string; cpr?: string; isChangeLogin?: boolean; };
  moduleDropdownConfig: any = {};
  CRDropdownConfig: any = {};

  chosenModule: { user?: {}, module?: { Label?: string, Value?: number } } = {};
  isModuleDropDownVisible: boolean = false;
  isLoginButtonDisabled: boolean = true;

  ticket: string = "";
  sessionId: string = "";
  //#endregion

  //#region [LifeCycle]
  constructor(
    private commonService: CommonService,
    private loginService: LoginService,
    private router: Router,
    private authService: EKeyAuthService,
    private applicantService: ApplicantManagementService,
    private userConfigService: UserConfigService,
    private translate: TranslateService,
    private appConfig: AppConfigService,
    private modalService: BsModalService,
    private dbService: NgxIndexedDBService) {
    let isProduction = JSON.parse(this.appConfig.getAppConfig().IsProduction);
    console.log("isProduction  = " + isProduction);
    let isEKey = JSON.parse(this.appConfig.getAppConfig().IsEKey);
    console.log("isEKey = " + isEKey);
    let isEKey2 = JSON.parse(this.appConfig.getAppConfig().IsEKey2);
    console.log("isEKey2  = " + isEKey2);
    let authSourceType = this.commonService.GetParametersByName('authSource');
    console.log("authSourceType  = " + authSourceType);
    this.authSource = JSON.parse(JSON.stringify(authSourceType));
    console.log("this.authSource  = " + this.authSource);

    if (isProduction) {
      if (isEKey2 && this.authSource === "ekey2") {
        console.log("if isEKey2 = true  ");
        this.EKeyTwoLogin();
      } else if (isEKey) {
        console.log("if isEKey = true  ");
        this.GetAuthenticationDetails();

      }
    } else {
      this.authenticationInfo.CPR = this.commonService.GetParametersByName('cpr');
      this.CPRNumber = JSON.parse(JSON.stringify(this.authenticationInfo.CPR));
      this.getUserCrs();
    }

    this.chosenModule = { user: {}, module: {} };
    this.currentUser = {
      lang: this.translate.currentLang,
      type: this.userConfigService.getUserType(),
      isChangeLogin: false
    }
  }
  ngOnInit(): void {
    this.selectedType = 1;
    this.currentUser.isChangeLogin = history.state.isChangeLogin !== null && history.state.isChangeLogin !== undefined ? history.state.isChangeLogin : false;
    if (this.currentUser.isChangeLogin) {
      this.retrieveCRandCPRFromIndexedDB();
    }
  }
  //#endregion

  //#region [Requests]
  GetAuthenticationDetails() {
    this.ticket = this.commonService.GetParametersByName('ticket');
    this.sessionId = this.commonService.GetParametersByName('clasSessionId');

    if (this.ticket && this.sessionId && (this.ticket !== '' || this.sessionId !== '')) {
      LoaderService.showLoader();
      this.applicantService.RequestingAuthenticationResult(
        { Ticket: this.ticket, SessionId: this.sessionId }).subscribe(
          response => {
            LoaderService.hideLoader();
            this.authenticationInfo = response["Result"];
            if (response["Status"] === "Success") {
              if (response["Result"]) {
                if (this.authenticationInfo && this.authenticationInfo.Status
                  && this.authenticationInfo.Status.toString() === "Success") {
                  this.CPRNumber = JSON.parse(JSON.stringify(this.authenticationInfo.CPR));
                  this.getUserCrs();
                }
              } else {
                this.router.navigate(['/error']);
              }
            } else {
              if (this.authenticationInfo && this.authenticationInfo.Status
                && this.authenticationInfo.Status.toString() !== "Success") {
                let backLabelText, failHeader, failBody = "";
                this.translate.get("Login-container.Message.TryAgain")
                  .subscribe(value => backLabelText = value);
                this.translate.get("Login-container.Message.AuthenticationFailed")
                  .subscribe(value => failHeader = value);
                this.translate.get("Login-container.Message.AuthenticationNotSuccessful")
                  .subscribe(value => failBody = value);
                const initialState = {
                  alertMode: Mode.Error,
                  alertHeader: failHeader,
                  alertMassage: failBody,
                  navigateOnExit: true,
                  exitNavigationURL: 'home',
                  enableNavigation: true,
                  backLableText: backLabelText,
                  navigationURL: 'login/redirect'
                };
                this.alertModalRef = this.modalService.show(
                  PopupNotificationComponent,
                  {
                    initialState,
                    backdrop: true,
                    ignoreBackdropClick: true,
                    keyboard: false,
                  },
                );
              } else {
                this.router.navigate(['/error']);
              }
            }
          }, (err) => {
            LoaderService.hideLoader();
            this.router.navigate(['/error']);
          });
    }
  }

  //login with CPR
  EKeyTwoLogin() {
    debugger;
     console.log("Enter EKeyTwoLogin Method...");
    let CPR = this.commonService.GetParametersByName('cpr');
    console.log("CPR  = " + CPR);
    this.CPRNumber = JSON.parse(JSON.stringify(CPR));
    console.log("CPRNumber  = " + this.CPRNumber);
    this.authenticationInfo.CPR = this.commonService.GetParametersByName('cpr');
    console.log("this.authenticationInfo.CPR  = " + this.authenticationInfo.CPR);

    const validCPR = this.authService.CheckCprNumber(CPR);
    console.log("validCPR  = " + validCPR);

    if (validCPR) {
      console.log("Enter condition if validCPR = true");
      this.getUserCrs();
    } else {
      console.log("Enter condition if validCPR = false");
      this.router.navigate(['/error']);
    }

  }


  getUserCrs() {
    debugger;
    console.log("Enter getUserCrs Method ...........");
    this.isLoginButtonDisabled = true;
    this.isModuleDropDownVisible = false;
    this.Modules = [];
    this.selectedCRNumber = "";

    this.showThereIsNoCrMessage = false;
    this.applicantCrs = [];
    this.CPRNumber = this.CPRNumber;

    if (this.selectedType == 1 && this.CPRNumber) {

       console.log("Enter if condition ..........");
      LoaderService.showLoader();
      this.userData = {
        UserCPR: this.CPRNumber,
        UserType: this.selectedType
      }

      console.log("this.CPRNumber  = " + this.CPRNumber);
      console.log("this.selectedType  = " + this.selectedType);

      this.loginService.post(this.userData, 'UserDataManager', 'GetCompanyCR').subscribe(
        (response: IGetOperationResponse<string[]>) => {
          this.setDDLConfigValues();
          LoaderService.hideLoader();

          console.log("response  = " + response);
          console.log("response.Result  = " + response.Result);
          console.log("response.Result.length  = " + response.Result.length);

          if (response && response.Result && response.Result.length > 0) {

            this.crsModules = response.Result as CrModules[];

            console.log("this.crsModules = " + this.crsModules);

            for (let i = 0; i < response.Result.length; i++) {
              this.applicantCrs.push({
                Key: this.crsModules[i].CR,
                Value: this.crsModules[i].CR
              });
            }
            if (this.applicantCrs.length === 1) {
              this.selectedCRNumber = this.applicantCrs[0].Key;
              this.prepareModule();
            }

            if (this.currentUser.isChangeLogin && this.currentUser.cpr === this.CPRNumber && this.currentUser.cr) {
              this.selectedCRNumber = this.currentUser.cr;
              this.CRDropdownConfig['placeholder'] = this.currentUser.cr;
              this.prepareModule();
            }
          } else {
            this.showThereIsNoCrMessage = true
            this.translate.get("Login-container.Labels.NoCPRMessage").subscribe(translatedValue => {
              this.message = translatedValue;
            });
          }
        },
        (err) => {
          LoaderService.hideLoader();
        },
        () => console.log('Calling api complete'))
    }
  }

  login() {
    debugger;
    if (this.currentUser.isChangeLogin || this.CPRNumber === this.authenticationInfo.CPR) {
      this.showErrorMessage = false;
      if (this.CPRNumber && (this.selectedCRNumber || this.selectedType == 2)) {
        LoaderService.showLoader();
        this.userData = {
          UserCPR: this.CPRNumber,
          UserType: this.selectedType,
          UserCR: this.selectedCRNumber,
          Module: this.selectedType == 1 ? this.chosenModule['module']["Value"] : 1
        }

        debugger;

        this.loginService.GetApplicantInfoByCPRandCR(this.userData).subscribe(
          (res: Response) => {
            LoaderService.hideLoader();

            // if(this.selectedType==1){
            this.addToUserLoginDB(this.CPRNumber, this.selectedCRNumber, this.chosenModule['module']["Value"]);
            // }

            debugger;
            var response = res['body'];
            // let sessionId =  response['Result']['SessionID'];
            // this.cookieService.set("SessionId",'ASP.NET_SessionId=' + sessionId);
            if (response && response['Result']) {
              debugger;
              this.applicantResponse = response['Result'];
              // sessionStorage.setItem("UserType", this.applicantResponse.UserType);
              if (this.applicantResponse.UserType == "2") {
                this.userConfigService.setUserConfig(this.applicantResponse.UserType, this.applicantResponse.UserName, this.applicantResponse.EnglishUserName,
                  this.applicantResponse.ArabicUserName, this.applicantResponse.AccessToken, 1, this.applicantResponse.IdleTimeoutValue, this
                    .applicantResponse.TokenExpiryTime, this.applicantResponse.InactivityTimeValueForAutomaticLogout);
                if (this.applicantResponse.IsNewlyCreated) {
                  this.userConfigService.setUserConfig(this.applicantResponse.UserType, this.applicantResponse.UserName, "Applicant Name", "اسم المتقدم", this.applicantResponse.AccessToken, 1, this.applicantResponse.IdleTimeoutValue, this.applicantResponse.TokenExpiryTime, this.applicantResponse.InactivityTimeValueForAutomaticLogout);
                  this.router.navigate(['/profile/edit']);
                  // this.router.navigate(['/workspace']);
                } else {
                  this.router.navigate(['/home']);
                }
              } else {
                debugger;
                this.userConfigService.setUserConfig(this.applicantResponse.UserType, this.applicantResponse.UserName, this.applicantResponse.EnglishUserName, this.applicantResponse.ArabicUserName, this.applicantResponse.AccessToken, this.chosenModule['module']["Value"], this.applicantResponse.IdleTimeoutValue, this.applicantResponse.TokenExpiryTime, this.applicantResponse.InactivityTimeValueForAutomaticLogout);
                // this.userConfigService.setLoggenInUserRole(this.applicantResponse.IsOwner, this.applicantResponse.IsPrimaryContact, this.applicantResponse.IsBoth);
                // window.location.href='/home';
                this.router.navigate(['/home']);

              }
              // this.userConfigService.updateUserName();
              // this.userConfigService.updateIsLoggedIn(true);
            } else {
              this.showErrorMessage = true;
              this.translate.get("Login-container.Labels.InvalidCPR").subscribe(translatedValue => {
                this.responseErrorMessage = translatedValue;
              });
            }

            localStorage.setItem('Module', this.userData.Module.toString());
          },
          (err) => {
            LoaderService.hideLoader();
            console.log(err)
          },
          () => console.log('Calling api complete'))
      }
    }
  }
  //#endregion

  //#region [Events]
  changeType(type) {
    this.selectedType = type;
    // this.applicantCrs = [];
    // this.isLoginButtonDisabled = true;
    // this.isModuleDropDownVisible = false;
    // this.Modules = [];

    if (this.currentUser.isChangeLogin && (!this.Modules || this.Modules.length === 0)) {
      this.getUserCrs();
    }
  }
  onChangeCPRValue() {
    this.showThereIsNoCrMessage = false;
    this.showErrorMessage = false;

    this.isLoginButtonDisabled = true;
    // this.isModuleDropDownVisible = false;

    this.applicantCrs = [];
    this.Modules = [];
  }
  changeCR() {
    if (this.selectedType == 1 && this.CPRNumber && this.selectedCRNumber) {
      this.chosenModule['module'] = {};
      this.prepareModule();
    }
  }
  SetModule(changeValue) {
    if (changeValue !== null && changeValue !== "") {
      this.resetModulesValues();
      this.chosenModule['module'] = this.Modules.filter(m => m.Value === changeValue)[0];
      this.isLoginButtonDisabled = false;
    } else {
      this.chosenModule['module'] = {};
      this.Modules.filter(m => m.Value === changeValue)[0];
      this.translate.get("Login-container.DropDown.modulePlaceholder")
        .subscribe(value => this.moduleDropdownConfig['placeholder'] = value);
      this.isLoginButtonDisabled = true;
    }
  }
  //#endregion

  //#region [Helper]
  resetModulesValues() {
    let initModules = JSON.parse(JSON.stringify(this.Modules));

    initModules.forEach(module => {
      let index = -1;
      index = this.Modules.indexOf(this.Modules.filter(m => m.Label === module.Label)[0]);
      if (index !== -1) {
        this.Modules[index].Value = this.currentUser.lang === 'en' ?
          UserConfigService.MTTModulesEn.filter(crm => crm.Label === this.Modules[index].Label)[0].Value
          : UserConfigService.MTTModulesAr.filter(crm => crm.Label === this.Modules[index].Label)[0].Value;
      }
    });
  }
  setDDLConfigValues() {
    // ---------------- CR drop down configuration values ------------------------
    this.CRDropdownConfig['displayKey'] = "Key",
      this.CRDropdownConfig['searchOnKey'] = "Key";
    this.CRDropdownConfig['search'] = true;
    this.translate.get("Login-container.DropDown.CRPlaceholder"
    ).subscribe(value => this.CRDropdownConfig['placeholder'] = value);
    this.translate.get("Login-container.DropDown.noResultsFound"
    ).subscribe(value => this.CRDropdownConfig['noResultsFound'] = value);
    this.translate.get("Login-container.DropDown.searchPlaceholder"
    ).subscribe(value => this.CRDropdownConfig['searchPlaceholder'] = value);

    // ---------------- module drop down configuration values ------------------------
    this.moduleDropdownConfig['displayKey'] = "Label",
      this.moduleDropdownConfig['searchOnKey'] = "Label";
    this.moduleDropdownConfig['search'] = true;
    this.translate.get("Login-container.DropDown.modulePlaceholder"
    ).subscribe(value => this.moduleDropdownConfig['placeholder'] = value);
    this.translate.get("Login-container.DropDown.noResultsFound"
    ).subscribe(value => this.moduleDropdownConfig['noResultsFound'] = value);
    this.translate.get("Login-container.DropDown.searchPlaceholder"
    ).subscribe(value => this.moduleDropdownConfig['searchPlaceholder'] = value);
  }
  prepareModule() {
     console.log("Enter prepareModule Method ......");

    this.Modules = this.crsModules.filter(crm => crm.CR === this.selectedCRNumber)[0].CompanyCategories !== null ?
      this.crsModules.filter(crm => crm.CR === this.selectedCRNumber)[0].CompanyCategories : [];
    if (this.Modules !== null || this.Modules.length > 0) {
      for (let i = 0; i < this.Modules.length; i++) {
        this.Modules[i].Label = this.currentUser.lang === 'en' ?
          UserConfigService.MTTModulesEn.filter(crm => crm.Value === this.Modules[i].Value)[0].Label
          : UserConfigService.MTTModulesAr.filter(crm => crm.Value === this.Modules[i].Value)[0].Label;
      }

      if (this.Modules.length === 1) {
        this.chosenModule['module'] = this.Modules[0];
      }

      this.isModuleDropDownVisible = true;
      this.getByCprForUserLoginDB(this.CPRNumber);
    }

    if (this.isModuleDropDownVisible && this.Modules.length === 1) {
      this.isLoginButtonDisabled = false;
    }

   console.log("End prepareModule Method ......");
 
  }
  //#endregion

  //#region [IndexedDB]
  addToUserLoginDB(cpr: string, cr: string, chosenModule: number) {
    this.dbService.getAll(UserLoginsDbStoreName).then(
      userLoginsDB => {
        console.log(userLoginsDB);
        if (userLoginsDB && userLoginsDB.length === 0) {
          this.dbService.add(UserLoginsDbStoreName, { Type: this.selectedType, CPR: cpr, CR: cr, ChosenModule: chosenModule }).then(
            () => { },
            error => {
              console.log(error);
            }
          );
        } else if (userLoginsDB && userLoginsDB.length === 1) {
          this.dbService.update(UserLoginsDbStoreName, { id: userLoginsDB[0]['id'], Type: this.selectedType, CPR: cpr, CR: cr, ChosenModule: chosenModule }).then(
            () => { },
            error => {
              console.log(error);
            }
          );
        } else {
          this.dbService.clear(UserLoginsDbStoreName).then(
            () => {
              this.dbService.add(UserLoginsDbStoreName, { Type: this.selectedType, CPR: cpr, CR: cr, ChosenModule: chosenModule }).then(
                () => { },
                error => {
                  console.log(error);
                }
              );
            },
            error => {
              console.log(error);
            }
          );
        }
      },
      error => {
        console.log(error);
      }
    );
  }
  getByCprForUserLoginDB(cpr: string) {
    console.log("Enter getByCprForUserLoginDB Method ........");
    
    this.retrievedModuleValue = -1;
    this.dbService.getByIndex(UserLoginsDbStoreName, 'CPR', cpr).then(
      loggedInUser => {
        console.log("loggedInUser  = " + loggedInUser);
        console.log("loggedInUser.CR  = " + loggedInUser.CR);
        console.log("this.selectedCRNumber  = "+ this.selectedCRNumber);

        if (loggedInUser && loggedInUser.CR === this.selectedCRNumber) {
          this.retrievedModuleValue = loggedInUser.ChosenModule;
          console.log("loggedInUser.ChosenModule  = "+ loggedInUser.ChosenModule);
          if (this.retrievedModuleValue !== -1) {
            let lastChosenModule = this.currentUser.lang === 'en' ?
              JSON.parse(JSON.stringify(UserConfigService.MTTModulesEn.filter(crm => crm.Value === this.retrievedModuleValue)[0]))
              : JSON.parse(JSON.stringify(UserConfigService.MTTModulesAr.filter(crm => crm.Value === this.retrievedModuleValue)[0]));

                console.log("lastChosenModule = "+ lastChosenModule);
                console.log("lastChosenModule = "+ lastChosenModule);
                console.log("lastChosenModule.Value  = "+ lastChosenModule.Value);

            if (lastChosenModule && lastChosenModule && lastChosenModule.Value) {
              let Index = -1;
              Index = this.Modules.indexOf(
                this.Modules.filter(m => m.Value === lastChosenModule.Value)[0]
              );
              if (Index !== -1) {
                this.chosenModule['module'] = lastChosenModule;
                this.moduleDropdownConfig['placeholder'] = this.chosenModule['module']['Label'];
                this.isLoginButtonDisabled = false;
              }
            }
          }
          else {
            this.translate.get("Login-container.DropDown.modulePlaceholder"
            ).subscribe(value => this.moduleDropdownConfig['placeholder'] = value);
            // this.isLoginButtonDisabled = true;
          }
        }
      },
      error => {
        this.translate.get("Login-container.DropDown.modulePlaceholder"
        ).subscribe(value => this.moduleDropdownConfig['placeholder'] = value);
        // this.isLoginButtonDisabled = true;
        console.log(error);
      }
    );
        console.log("End getByCprForUserLoginDB Method ........");

  }
  retrieveCRandCPRFromIndexedDB() {
    console.log("Enter retrieveCRandCPRFromIndexedDB Method ........");
    this.dbService.getAll(UserLoginsDbStoreName).then(
      loggedInUsers => {
        if (loggedInUsers && loggedInUsers.length > 0 && loggedInUsers[0]['CR'] && loggedInUsers[0]['CPR'] && loggedInUsers[0]['Type']) {
          this.currentUser.cpr = loggedInUsers[0]['CPR'];
          this.currentUser.cr = loggedInUsers[0]['CR'];
          this.CPRNumber = loggedInUsers[0]['CPR'];
          this.selectedType = loggedInUsers[0]['Type'];
          this.getUserCrs();
        } else if (loggedInUsers && loggedInUsers.length > 0 && loggedInUsers[0]['CPR'] && loggedInUsers[0]['Type']) {
          this.currentUser.cpr = loggedInUsers[0]['CPR'];
          this.CPRNumber = loggedInUsers[0]['CPR'];
          //this.selectedType = loggedInUsers[0]['Type'];
          this.getUserCrs();
        }
      },
      error => {
        console.error(error);
      }
    );
  }
  //#endregion
}

export interface CrModules {
  CR?: string,
  CompanyCategories?: IOptionSetItem[]
}
